$(document).ready(function(){
    $('body').on('click','[addToCart]', function(e){
    
        e.preventDefault();
        $(this).addClass('disabled-btn');
        $(this).find('span').show();
        let atcFlag = true;
        $('.mask').each(function(){
            var limit = $(this).data('limit');
            var $length = $(this).next().find('.modal-content .selected').length;
            var $collection = $(this).data('collection');
            if(limit > $length){
                alert('please select at least '+ limit +' '+$collection);
                atcFlag = false;
                return false;
            }
        });
        
        if(atcFlag == true)
        {
            if(papaya_burst == true)
                mainProduct = $(this).data('variant2');
            else
                mainProduct = $(this).data('variant1');
            setTimeout(() => {
                addAllItems();
            }, 2000);
        }
        else{
            $(this).find('.loader').hide();
            $(this).removeClass('disabled-btn');
        }
    })
});
let variant_array = [];
let mainProduct,
    papaya_burst;

checkAdded();
// Add addon to array
$('body').on('click', '[data-add-ons]',function(){
    var variant_id =$(this).data('variant');
    if(jQuery.inArray( variant_id, variant_array ) < 0){
        variant_array.push(variant_id+'_0');
        checkAdded('0');
    }
});
// Add bundle product to array
$('body').on('click', '[data-add-wrap]', function(e){
    var product_handle = $(this).find('[data-add]').data('handle');
    if(product_handle.indexOf('papaya-burst') > -1){
        papaya_burst = true;
    }

    var variant_id =$(this).find('[data-add]').data('variant'),
    modal = $(this).closest('.modal').attr('data-modal-no');
    limit = $(this).closest('.modal').prev().data('limit'),
    totalSelected = $(this).closest('.modal').find('.selected').length;

    if(limit == 1){
        $(this).closest('.modal').find('[data-add]').addClass('disabled-btn');
        $(this).closest('.modal').find('.selected').each(function(i){
            let selected = $(this).closest('.modal').find('.selected').data('variant') +'_'+ modal;
            removeA(variant_array, selected);
        });
    }else if(totalSelected >= limit){
        let $this = $(this);
        let removeId;
        variant_array.forEach(function(item, i){
            $this.closest('.modal').find('.selected').each(function(i){
                var variant = $(this).data('variant')+'_'+modal;
                if(variant == item){
                    if(removeId == undefined || removeId == ''){
                        removeId = item;
                    }
                }
            });

        });
        removeA(variant_array, removeId);
    }
    else{
        $(this).closest('.modal').find('[data-add]').addClass('disabled-btn');
    }
    setTimeout(() => {
        variant_array.push(variant_id+'_'+modal);
        checkAdded(modal);
    }, 200);
});

// function for add variant in array and make select button as selected.
function checkAdded(modal){
    $('.addToCart').each(function(){
        let allProduct;
        let variant_id =$(this).data('variant')+ '_' + modal;
        $modal = $(this).closest('.modal').prev().data('collection');
        $modalNo = $(this).closest('.modal').data('modal-no');
        if(jQuery.inArray( variant_id, variant_array ) > -1 && $modalNo == modal){
            if($(this).text() == 'select' || $(this).text() == 'Select')
                {
                    $(this).addClass('selected').text('selected');
                    
                    var $collection = $( "[data-collection = '"+ $modal +"']" ).data('modal');
                    $wrap = $(this).closest('.modal');
                    var addedProduct = '';
                    // text above step select button
                    $wrap.find('.addToCart.selected').each(function(){
                        $(this).data('product');
                        if(addedProduct == '' || addedProduct == undefined){
                            addedProduct = $(this).data('product');
                        }else{
                            addedProduct = addedProduct +', '+ $(this).data('product');
                        }
                        $( "[data-collection = '"+ $collection +"']" ).prev('.added-product').text('Selected Product: '+ addedProduct);
                        $('.modal').find('[data-add]').removeClass('disabled-btn');
                    });
                }
            else if($(this).text() == 'Add' || $(this).text() == 'add')
                {$(this).addClass('selected').text('added');}
            $(this).attr('disabled', true);
        }else if($(this).closest('.modal').attr('data-modal-no') == modal){
            if($(this).text() == 'selected')
                {$(this).removeClass('selected').text('Select');}
            else if($(this).text() == 'added')
                {$(this).removeClass('selected').text('add');}
            $(this).removeAttr('disabled');
        }
        // text above the checkout button
        $('.modal .selected').each(function(){
            if(allProduct == '' || allProduct == undefined){
                allProduct = $(this).data('product');
                $('[data-all-product]').text('Selected product: '+ allProduct);
            }else{
                allProduct = allProduct +', '+ $(this).data('product');
                $('[data-all-product]').text('Selected product: '+ allProduct);
            } 
        });

    });
}

// function for remove variant from variant array
function removeA(arr) {
    var what, a = arguments, L = a.length, ax;
    while (L > 1 && arr.length) {
        what = a[--L];
        while ((ax= arr.indexOf(what)) !== -1) {
            arr.splice(ax, 1);
        }
    }
    return arr;
}

// ATC function for with bundle
function addAllItems(){
    let random_no = Math.floor(100000 + Math.random() * 900000);
    let $products = [];
    let $bundleProducts = $('[data-all-product]').text().split('Selected product: ');
    
   
    $('.modal .collection-menu-button-sortby.selected').each(function(i,e){
        var varId = $(this).data('variant');
        $products.push({
          variant_id:varId,
          quantity:1,
          _randomNumber: random_no,
          producttype: "Sub Product",
        });	
    });
    $('.best-seller-items .collection-menu-button-sortby.selected').each(function(i,e){
        var varId = $(this).data('variant');
        $products.push({
          variant_id:varId,
          quantity:1,
          _randomNumber: random_no,
          producttype: "Addon Product",
        });	
    });
    
    $products.push({
        variant_id: mainProduct,
        quantity:1,
        _randomNumber: random_no,
        producttype:"Main Product"
    });

    $.each($products, function (i){ 
        let variantId = $products[i].variant_id,
            qty = $products[i].quantity,
            random = $products[i]._randomNumber,
            producttype = $products[i].producttype,
            properties;
        if(producttype == "Main Product"){
            properties = {
                '_bundle_id': random,
                'Product Type': producttype,
                'Bundle Product': $bundleProducts[1]
            }
        }else{
            properties = {
                '_bundle_id': random,
                'Product Type': producttype
            }
        }
        
        var data_ajax = {
          "quantity": qty,
          "id": variantId,
          "properties": properties
        }
        var params = {
          type: 'POST',
          url: '/cart/add.js',
          data: data_ajax,
          dataType: 'json',
          async: false,
          success: function (responce) {
            
              if($products.length-1 == i){
                window.location.href = '/cart';
                setTimeout(function(){
//                     $('.site-actions-cart a').click();
//                     $('.header-minicart').addClass('open');
                    $('[addtocart] .loader').hide();
                    $('[addtocart]').removeClass('disabled-btn');
                },500);
              }
          },
          error: function (er) {
            var err = $.parseJSON(er.responseText);
            return false;
          }
        }
        $.ajax(params);
      });
  };

// For modal open and close functions start
$("body").on("click", '.show', function(){
    var collection = $(this).data('collection');
    $(".mask." + collection ).addClass("active");
    var modalNo = $(this).data('modal');
    var elem = document.querySelector('.modal-'+ modalNo+' .bundle-product');
    var flkty = new Flickity( elem, {
      cellAlign: "left", 
      contain: true, 
      pageDots: false
    });
    
    var flkty = new Flickity('.modal-'+ modalNo+' .bundle-product', {
    });
    setTimeout(function(){
        let title_height = 0;
        $('.mask.active').next().find('article .product-item-title').each(function(){
            if(title_height < $(this).height()){
                title_height = $(this).height()
            }
        });
        $('.mask.active').next().find('article .product-item-title').css('height', title_height);

        let image_height = 0;
        $('.mask.active').next().find('article .product-item-image').each(function(){
            if(image_height < $(this).height()){
                image_height = $(this).height()
            }
        });
        $('.mask.active').next().find('article .product-item-image').css('height', image_height);
    },20);
});
// function for close modal
function closeModal(){
  $(".mask").removeClass("active");
}

// Remove function with bundle
function removeBundle(id){
   if(id != undefined){
   
    var Uid = id;
    var $this = $(this).closest('article');
    var finalQty= 0;
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json'
        }).done(function (response) {
            let ProductArray = [];
            $(response.items).each(function(index, item){
                if (item.properties != undefined && item.properties._bundle_id != undefined) {
                    var RadomNo = item.properties['_bundle_id'];
                    var itemKey = item.key;
                    if(Uid == RadomNo){
                        ProductArray.push(finalQty);
                    }else{
                        ProductArray.push(item.quantity);
                    }
                }else{
                    ProductArray.push(item.quantity);
                }
            });
            jQuery.post('/cart/update.js', {updates: ProductArray}).done(function(){
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            }).fail(function(error) {
              setTimeout(() => {
                    window.location.reload();
                }, 1000);
            });;
        });

    }
}
// Call the closeModal function on the clicks/keyboard
$(".close, .mask").on("click", function(){
  closeModal();
});
$(document).keyup(function(e) {
  if (e.keyCode == 27) {
    closeModal();
  }
});

// For modal open and close functions End
